export default {
  serviceTitle: '用戶服務協議',
  service01: '提示：在使用本產品和服務之前，您應認真閱讀並遵守《用戶服務協議》（以下簡稱「本協議」）和',
  service02: '《隱私保護政策》',
  service03: '。請您務必審慎閱讀、充分理解各條款內容，特別是免除或限制責任的條款、爭議解決和法律適用條款。 ',
  service04: '當您依照頁面指示閱讀並同意本協議後，即表示您已充分瞭解並接受本協議的全部內容，本協議即產生法律約束力。 ',
  service05: '一、締約主體',
  service06: '本協議由透過網站、行動端和桌面端應用軟體、硬體以及其他方式使用我們服務的使用者（以下簡稱「使用者」或「您」）與{company}（以下簡稱「我們」或“公司”）共同締結。 ',
  service07: '二、協議內容和效力',
  service08: '1、本協議內容包括本協議正文和所有我們已經發布或將來可能發布的各項政策、規則、聲明、通知、警示、提示和說明（以下簡稱「規則」）。前述規則為本協議不可分割的組成部分，與本協議具有同等法律效力。 ',
  service09: '2、我們有權根據需要不時制訂、修改本協議和相關規則，變更後的協議和規則將取代原協議和規則生效。如您不同意相關變更，應立即停止使用我們的服務，如您繼續使用我們的服務或進行任何網站活動，即表示您已接受經修訂的協議和規則。 ',
  service10: '三、服務內容',
  service11: '1、我們的產品和服務包括官網、行動用戶端和桌面用戶端。本協議不適用於其他第三方透過前述網頁或用戶端直接提供給您的服務（統稱「第三方服務」）。 ',
  service12: '2、我們有權自行決定對服務或服務的任何部分及其相關功能進行變更、升級、修改和轉移。 ',
  service13: '四、帳號管理',
  service14: '1、您在使用我們的服務時，可能需要註冊帳號。您確認，在您完成註冊帳號並實際使用我們的服務時，應是具備完全民事權利能力和與所從事的民事行為相適應的行為能力的自然人、法人或其他組織。若您不具備前述主體資格，請勿使用我們的服務，否則您和您的監護人應承擔因此而導致的一切後果，且我們有權註銷（永久凍結）您的帳戶，並向您和您的監護人索償。如您代表一家企業、組織機構或其他法律主體進行註冊或以其他我們允許的方式實際使用本服務，則您聲明和保證，您已經獲得充分授權並有權代表該公司、組織機構或法律主體註冊使用我們的服務，並接受本協議的約束。 ',
  service15: '2、您在使用我們的服務時，應遵守法律法規，不得利用我們的服務從事違法犯罪活動，不得利用我們的服務侵犯他人合法權益。 ',
  service16: '3、您了解並同意，您註冊的帳號（包括客戶端帳號和服務管理帳號）所有權歸屬於我們，註冊完成後，您僅獲得帳號使用權。帳號使用權僅歸屬於初始申請註冊人，不得以任何方式轉讓或提供給他人使用，否則，我們有權不經通知立即收回該帳號，由此帶來的因您使用本服務產生的全部資料、資訊等被清空、遺失等的損失，您應自行承擔。 ',
  service17: '五、聯絡我們',
  service18: '如果有任何疑問、意見或請求，你可以將相關問題發送至',
  service19: '。一般情況下，我們會在收到你相關聯絡資訊並核實你身分後的十五個工作天內回覆。 ',
  service20: '對於與你的身份不直接關聯的信息、無效重複信息，或者需要過多技術手段、給他人合法權益帶來風險或者不切實際的請求，我們可能會予以拒絕。 ',
  personalInformationTitle: '個人資料蒐集清單',
  personalInformation01: '我們會收集你在使用服務時主動提供的、透過自動化手段收集的你在使用功能或接受服務過程中產生的下述資訊。 ',
  personalInformation02: '溫馨提示：我們會根據向您提供更穩定豐富的產品及服務、維護本服務的正常安全運作、優化本服務的功能體驗，處理您在使用相關服務或功能時的個人資訊。在為您提供產品及服務的過程中，由於您選擇的功能範圍及軟體版本的不同等原因，收集和處理個人資訊的範圍可能會有所不同，請以特定的服務或功能為準。個人資訊的收集處理詳情可參閱',
  personalInformation03: '《隱私保護政策》',
  personalInformation04: '。 ',
  personalInformationTable01: '可能收集個人資料的場景',
  personalInformationTable02: '可能收集的個人資訊',
  personalInformationTable03: '個人資訊的使用目的',
  personalInformationTable04: '帳號',
  personalInformationTable05: '手機號碼',
  personalInformationTable06: '密碼',
  personalInformationTable07: '信箱',
  personalInformationTable08: '用於註冊和登入',
  personalInformationTable09: '頭像',
  personalInformationTable10: '性別',
  personalInformationTable11: '出生日期',
  personalInformationTable12: '使用者自行填寫的個人資料',
  personalInformationTable13: '搜尋',
  personalInformationTable14: '搜尋關鍵字',
  personalInformationTable15: '用來顯示搜尋結果與搜尋記錄',
  personalInformationTable16: '營運與安全保障',
  personalInformationTable17: '裝置型號與設定',
  personalInformationTable18: '作業系統版本與設定',
  personalInformationTable19: '裝置名稱、時區與設定',
  personalInformationTable20: '裝置識別碼',
  personalInformationTable21: '網路設備硬體 MAC 位址',
  personalInformationTable22: '硬體序號（SN）',
  personalInformationTable23: 'IP 位址',
  personalInformationTable24: 'WLAN 接入點',
  personalInformationTable25: '藍牙與基地台',
  personalInformationTable26: '軟體版本號',
  personalInformationTable27: '網路存取方式、類型與品質',
  personalInformationTable28: '服務日誌',
  personalInformationTable29: '套用資訊、使用量、使用頻率、崩潰狀況、效能資料',
  personalInformationTable30: 'MAC 位址和硬體序號（SN）由整合的第三方廣告 SDK 收集和使用，用於廣告效果統計與歸因；其他資訊用於保障營運與使用安全，提供服務品質與效率',
  openSourceTitle: '開源組件版權聲明',
  openSourceTable01: '組件名稱',
  openSourceTable02: '許可證資料',
  openSourceTable03: '是否經過更改',
  openSourceTable04: '是',
  openSourceTable05: '否',
  authorizationTitle: '權限使用規則',
  authorization01: '為了保障產品功能實現與安全穩定運作之目的，我們可能會申請或使用作業系統的相關權限。為了保障您的知情權，我們透過下列清單將產品可能申請、使用的相關作業系統權限進行展示，您可以依照實際需求對相關權限進行管理。 ',
  authorization02: '根據產品的升級，申請、使用權限的類型與目的可能會有變動，我們將及時根據這些變動對清單進行調整，以確保您及時獲悉權限的申請與使用情況。如果您想要知悉我們如何收集、使用、儲存、分享和轉讓用戶信息，以及我們如何保護用戶信息，請查閱',
  authorization03: '《隱私保護政策》',
  authorization04: '。',
  authorizationTable01: '權限名稱',
  authorizationTable02: '權限說明',
  authorizationTable03: '使用場景或目的',
  privacySummaryTitle: '隱私政策摘要',
  privacySummaryTitle01: '一、我們如何收集和使用使用者資訊',
  privacySummaryTitle02: '二、權限使用說明',
  privacySummaryTitle03: '三、涉及收集使用者資訊的第三方 SDK 資訊說明',
  privacySummaryTitle04: '四、管理您的個人資料',
  privacySummary01: '{company}（簡稱「我們」）深知個人資訊安全與隱私保護非常重要，本摘要將幫助您直觀、簡潔地了解我們是如何收集、處理使用個人資訊以及如何保護您的隱私。更多完整、詳細資訊請閱讀完整的',
  privacySummary02: '《隱私保護政策》',
  privacySummary03: '。 ',
  privacySummary04: '1、帳號註冊：您在使用我們的服務時，可能需要註冊帳號。我們會收集您的帳號和密碼以便註冊和登入。 ',
  privacySummary05: '2、使用資訊：我們會收集您使用服務時提交或產生的資訊。 ',
  privacySummary06: '3、設備資訊：我們會根據您在軟體安裝及使用中授予的具體權限，接收並記錄您所使用的設備相關資訊。 ',
  privacySummary07: '4、日誌資訊： 當您使用我們提供的產品或服務時，我們會自動收集您對我們服務的詳細使用情況，作為有關網誌儲存。 ',
  privacySummary08: '5、安全保障： 為提高您使用我們及我們關聯公司、合作夥伴提供服務的安全性，保護您或其他用戶或公眾的人身財產安全免遭侵害，我們可能使用或整合您的設備信息、軟體使用資訊以及我們關聯公司、合作夥伴取得您授權或依據法律共享的信息，用於進行身份驗證、檢測及防範安全事件，並依法採取必要的記錄、審計、分析、處置措施。 ',
  privacySummary09: '為了向您提供服務、保障服務的正常運作以及保障您的帳號安全，我們需要根據您所使用的服務場景，在徵得您同意後向您索取位置、存儲、相機、麥克風、通訊錄等相關權限。 ',
  privacySummary10: '為了保障我們的服務穩定運作或實現相關功能，我們可能會接入由第三方提供的軟體開發包（SDK）實現前述目的。我們會盡到審慎義務，對合作方取得資訊的軟體工具開發包（SDK）進行嚴格的安全監測，以保護資料安全。 ',
  privacySummary11: '如果您在使用我們的服務時，已經註冊了一個帳號。您可以提交註銷帳號申請。在您申請註銷帳號之前，請確認您的帳號錢包無餘額，註銷帳號的申請提交成功之後，管理員會對您的帳號進行相關處理。在管理員處理您的帳號之前，您仍然可以正常登入。 ',
  thirdPartyTitle: '接入合作方目錄',
  thirdPartyTitle01: '穿山甲',
  thirdPartyTitle02: 'AdMob',
  thirdParty01: '為了保障相關功能的實現與應用安全穩定的運行，我們可能會接入由合作方提供的軟體開發包（SDK）、應用程式介面（API）、應用程式外掛程式等程式碼或透過其他合作方式，以實現相關目的。我們會對獲取資訊的合作方的代碼進行嚴格的安全監測，以保護資料安全。 ',
  thirdParty02: '我們對接入的相關合作方在下面的目錄中列明，合作方具體的處理情況請參見合作方的隱私權政策或服務協議。請注意，合作方的程式碼可能會因為其版本升級、策略調整等原因導致資料處理類型有一定變化，請以其公示的官方說明為準。 ',
  thirdParty03: '功能：用於行動裝置展示廣告',
  thirdParty04: '收集個人資訊類型：裝置資訊、網路資訊、應用程式資訊、感測器資訊、廣告資訊、裝置連網識別碼 MAC 位址、軟體安裝清單、位置資訊和效能資料',
  thirdParty05: '隱私權政策連結：https://www.csjplatform.com/privacy/partner',
  thirdParty06: '第三方主體：北京巨量引擎網路技術有限公司',
  thirdParty07: '功能：用於行動裝置展示廣告',
  thirdParty08: '收集個人資訊類型：裝置識別碼、行動廣告識別碼、裝置連網識別碼 MAC 位址、軟體安裝清單和位置資訊',
  thirdParty09: '隱私權政策連結：https://policies.google.com/privacy',
  thirdParty10: '第三方主體：Google LLC',
  privacyTitle: '隱私權保護政策',
  privacyTitle01: '1. 本服務如何蒐集及使用個人資訊',
  privacyTitle0101: '1.1. 帳號服務',
  privacyTitle0102: '1.2. 搜尋',
  privacyTitle0103: '1.3. 安全運作',
  privacyTitle0104: '1.4. 複製與分享',
  privacyTitle0105: '1.5. 使用者回饋',
  privacyTitle0106: '1.6. 收集、使用個人資訊目的變更',
  privacyTitle0107: '1.7. 徵得授權同意的例外',
  privacyTitle02: '2. 我們如何使用Cookie和同類技術',
  privacyTitle03: '3. 資料處理過程中涉及的合作方以及轉移、公開個人資訊',
  privacyTitle0301: '3.1. 資料處理過程中涉及的合作方',
  privacyTitle0302: '3.2. 轉移',
  privacyTitle0303: '3.3. 公開',
  privacyTitle0304: '3.4. 依法豁免徵得同意提供、公開的個人資訊',
  privacyTitle04: '4. 我們如何儲存個人資訊',
  privacyTitle0401: '4.1. 存放地點',
  privacyTitle0402: '4.2. 儲存期限',
  privacyTitle05: '5. 我們如何保護個人資訊的安全',
  privacyTitle06: '6. 管理你的個人資訊',
  privacyTitle0601: '6.1. 設定管理',
  privacyTitle0602: '6.2. 意見回饋與投訴檢舉',
  privacyTitle0603: '6.3. 存取隱私權政策',
  privacyTitle0604: '6.4. 停止營運並向你公告',
  privacyTitle07: '7. 未成年條款',
  privacyTitle08: '8. 隱私權政策的修訂和通知',
  privacyTitle09: '9. 聯絡我們',
  privacyTitle10: '10. 其他',
  privacy00: '更新日期：2025年01月25日',
  privacy01: '{company}（以下簡稱「我們」）身為本產品及服務的經營者，深知個人資訊對你的重要性，我們將依照法律法規的規定，保護你的個人資訊及隱私安全。我們制定本隱私權政策並希望提示你了解下述內容，以便做出適當選擇。 ',
  privacy02: '本隱私權政策寫明了在不同場景下我們處理你的個人信息的方式，為了幫助你更加直觀、簡明地了解我們如何收集、使用以及保護你的個人信息，我們也為你提供了內容更簡潔的',
  privacy03: '《隱私權政策摘要》',
  privacy04: '，該指引為本隱私權政策的一部分。 ',
  privacy05: '當你開啟相關功能、使用相關服務時，我們會收集相關資訊。除非是為實現產品功能或根據法律法規要求所必需的信息，你均可以拒絕提供且不影響其他功能或服務，詳情可以通過',
  privacy06: '《個人資料蒐集清單》',
  privacy07: '查閱。 ',
  privacy08: '通訊錄、精確地理位置、麥克風、相機、相簿、日曆權限等均不會默認開啟，只有經過你的明示授權才會在實現特定功能或服務時使用，你也可以撤回授權。特別需要指出的是，即使經過了你的授權，我們獲得了這些敏感權限，也不會在相關功能或服務不需要時收集這些信息，詳情可以通過',
  privacy09: '《權限使用規則》',
  privacy10: '查閱。 ',
  privacy11: '本隱私權政策適用於我們的產品及服務，包括用戶端應用程式、小程式、官方網站和其他由我們提供且使用本隱私權政策的所有產品及服務（以下統稱「本服務」）。本隱私權政策不適用於其他第三方提供你的服務，你應在選擇使用第三方服務前充分了解第三方服務的產品功能及隱私權保護政策，再選擇是否使用對應功能或服務。 ',
  privacy12: '除本隱私權政策外，在特定場景下，我們也會透過即時告知（含彈窗、頁面提示等）、功能更新說明等方式，向你說明對應的資訊收集目的、範圍及使用方式，這些即時告知及功能更新說明等構成本隱私權政策的一部分，並與本隱私權政策具有同等效力。 ',
  privacy13: '下文將幫助你詳細了解我們如何收集、使用、儲存、轉移（如適用）與保護你的個人資訊。並且幫你了解查詢、複製、刪除、更正、撤回授權個人資訊的方式。本政策與你使用我們的服務關係密切，我們建議你仔細閱讀並理解本政策全部內容，並做出你認為適當的選擇。 ',
  privacy14: '為了向你提供本服務、維護本服務的正常安全運行、優化本服務的功能體驗，我們會按照以下目的與方式，收集你在使用本服務時主動提供、授權提供的個人信息，以及你使用本服務時所產生的個人資訊：',
  privacy16: '你可以根據自己的需求，自主填寫或設置頭像、個性簽名、個人狀態等信息，這些你主動填寫或設置的個人資料將用於向其他用戶展示。不填寫或設定這些資訊不會影響你使用我們的服務。 ',
  privacy17: '你使用搜尋功能時，我們會收集你的搜尋關鍵字資訊、日誌記錄，以便向你顯示搜尋結果內容、搜尋記錄。搜尋關鍵字資訊會同時儲存在你的裝置和我們的服務端，你可以點擊搜尋框，查看和刪除對應儲存在本裝置和服務端的搜尋記錄關鍵字。 ',
  privacy18: '我們致力於為你提供安全、可信的產品與使用環境，提供優質而可靠的服務與資訊是我們的核心目標。為了維護我們服務的正常運行，保護你或其他使用者或公眾的合法利益免受損失，我們會收集用於維護產品或服務安全穩定運行的必要資訊。 ',
  privacy19: '為了確保軟體與服務的安全運作、營運的品質及效率，我們會收集你的：硬體型號、作業系統版本號、裝置識別碼、軟體安裝清單、IP 位址、WLAN 存取點、基地台、軟體版本號、網路存取方式、類型、狀態、網路品質資料、操作、使用、服務日誌、裝置時區、裝置名稱、CPUID、主機板序號、硬碟序號。為了進行廣告效果統計與歸因，本服務整合的第三方廣告 SDK 會收集和使用你的網路設備硬體位址（裝置 MAC 位址）、硬體序號（SN）。',
  privacy20: '為了預防惡意程式、保障營運品質及效率，我們會收集你安裝的應用程式資訊（如版本、語言、來源等）、流程資訊、整體運作、使用情況與頻率、應用崩潰、效能資料。 ',
  privacy21: '我們可能使用你的帳號資訊、設備資訊、服務日誌資訊以及我們關聯方、合作方在獲得你授權或依法可以提供的信息，用於判斷帳戶及交易安全、進行身份驗證、識別違法違規情況、偵測及防範安全事件，並依法採取必要的記錄、分析、處置措施。 ',
  privacy22: '在你分享、複製信息時，我們需要訪問你的剪切板，讀取其中包含的口令、分享碼、鏈接及其他內容信息，以實現跳轉、複製、分享等功能或服務。 ',
  privacy23: '在使用本服務過程中，你可以對使用過程中遇到的問題及服務體驗進行問題反饋，幫助我們更好地了解你使用我們產品或服務的體驗和需求，在幫你解決問題的同時，幫助我們改善產品和服務，為此我們會記錄你的聯絡資訊、回饋的問題或建議、你與我們的通訊/通話記錄及相關內容，以便我們進一步聯絡你，向你回饋我們的處理進度。 ',
  privacy24: '請你了解，隨著我們業務的發展，可能會對我們的功能和提供的服務有所調整變化。原則上，當新功能或服務與我們目前提供的功能或服務相關時，收集與使用的個人資訊將與原始處理目的有直接或合理關聯。在與原處理目的無直接或合理關聯的場景下，我們收集、使用你的個人信息，會再次按照法律法規及國家標準的要求以頁面提示、交互流程、協議確認等合理的方式另行向你進行告知說明，並徵得你的同意。 ',
  privacy25: '請你瞭解，在下列情形中，根據法律法規及相關國家標準，我們收集和使用你的個人資訊無需徵得你的授權同意：',
  privacy26: '與我們履行法律法規規定的義務相關的；',
  privacy27: '與國家安全、國防安全直接相關的；',
  privacy28: '與公共安全、公共衛生、重大公共利益直接相關的；',
  privacy29: '與犯罪偵查、起訴、審判和判決執行等直接相關的；',
  privacy30: '出於維護個人資訊主體或其他個人的生命、財產等重大合法權益但又很難得到本人同意的；',
  privacy31: '所收集的你的個人資料是你自行向社會公眾公開的；',
  privacy32: '從合法公開披露的信息中收集的你的個人信息的，如合法的新聞報道、政府信息公開等渠道；',
  privacy33: '根據你的要求簽訂或履行合約所必需的；',
  privacy34: '用於維護軟體及相關服務的安全穩定運作所必需的，例如發現、處置軟體及相關服務的故障；',
  privacy35: '為合法的新聞報道所必需的；',
  privacy36: '學術研究機構基於公共利益開展統計或學術研究所必要，且對外提供學術研究或描述的結果時，對結果中所包含的個人信息進行去標識化處理的；',
  privacy37: '法令規定的其他情形。 ',
  privacy38: '我們使用Cookie和其他類似技術，以提升你使用本服務的體驗。當你使用本服務時，我們可能會使用相關技術向你的裝置發送一個或多個 Cookie 或匿名標識符，以收集和儲存你存取、使用本服務時的資訊。我們承諾，不會將 Cookie 用於本隱私權政策所述目的以外的任何其他用途。我們使用 Cookie 和同類技術主要為了實現以下功能或服務：',
  privacy39: '保障產品與服務的安全、高效運作：我們可能會設定認證與保障安全性的 Cookie 或匿名識別符，使我們確認你是否安全登入服務，或是否遇到盜用、詐欺及其他不法行為。這些技術也會幫助我們改善服務效率，提升登入和回應速度；',
  privacy40: '幫助你獲得更輕鬆的訪問體驗：使用此類技術可以幫助你省去重複你填寫個人資訊、輸入搜尋內容的步驟和流程（範例：記錄搜尋、表單填寫）。 ',
  privacy41: '大多數瀏覽器皆為使用者提供了清除瀏覽器快取資料的功能，你可以在瀏覽器設定功能中進行對應的資料清除操作。如你進行清除，你可能無法使用由我們提供的、依賴 Cookie 的服務或相應功能。 ',
  privacy42: '與合作方合作過程中涉及資料使用活動的，必須具有合法目的、符合法定的合法性基礎。如果合作方使用資訊不再符合合法原則，則其不應再使用你的個人訊息，或在獲得相應合法性基礎後再行使用。 ',
  privacy43: '我們將審慎評估合作方使用資料的目的，對這些合作方的安全保障能力進行全面評估，並要求其遵循合作法律協議。我們會對合作方取得資訊的軟體工具開發包（SDK）、應用程式介面（API）進行嚴格的安全監測，以保護資料安全，詳情可以透過',
  privacy44: '《接入合作方目錄》',
  privacy45: '查閱。 ',
  privacy46: '隨著我們業務的持續發展，我們將有可能進行合併、收購、資產轉讓，你的個人資訊有可能因此而被轉移。在發生前述變更時，我們將按照法律法規及不低於本隱私權政策所要求的安全標準繼續保護或要求個人資訊的繼任者繼續保護你的個人信息，否則我們將要求繼任者重新徵得你的授權同意。 ',
  privacy47: '我們不會公開你的信息，除非遵循國家法律法規規定、基於你的主動選擇或獲得你的同意。我們公開你的個人資訊會採用符合業界標準的安全保護措施。 ',
  privacy48: '請你瞭解，在下列情形中，根據法律法規及國家標準，我們向合作方或第三方提供、公開你的個人資訊無需徵得你的授權同意：',
  privacy49: '與我們履行法律法規規定的義務相關的；',
  privacy50: '與國家安全、國防安全直接相關的；',
  privacy51: '與公共安全、公共衛生、重大公共利益直接相關的；',
  privacy52: '與犯罪偵查、起訴、審判和判決執行等直接相關的；',
  privacy53: '出於維護個人資訊主體或其他個人的生命、財產等重大合法權益但又很難得到本人同意的；',
  privacy54: '所收集的你的個人資料是你自行向社會公眾公開的；',
  privacy55: '從合法公開披露的信息中收集的你的個人信息的，如合法的新聞報道、政府信息公開等渠道；',
  privacy56: '根據你的要求簽訂或履行合約所必需的；',
  privacy57: '用於維護軟體及相關服務的安全穩定運作所必需的，例如發現、處置軟體及相關服務的故障；',
  privacy58: '為合法的新聞報道所必需的；',
  privacy59: '學術研究機構基於公共利益開展統計或學術研究所必要，且對外提供學術研究或描述的結果時，對結果中所包含的個人信息進行去標識化處理的；',
  privacy60: '法令規定的其他情形。 ',
  privacy61: '我們依照法律法規的規定，將在境內運作過程中收集和產生的你的個人資訊儲存於中華人民共和國境內。目前，我們不會將你的個人資訊傳輸至境外，如果基於滿足管理需求向境外傳輸，我們將會遵循相關國家規定保護你的個人資訊。 ',
  privacy62: '你在使用本服務期間，我們將持續保存你的個人信息，保存期限將以不超過提供服務所必須的期間為原則。如我們停止經營本服務、你主動刪除個人資訊或超出必要期間後，我們將在合理期限內依照所適用的法律對所持有的你的個人資訊進行刪除或匿名化處理。但以下情況除外：',
  privacy63: '遵從法律法規有關資訊留存的要求（例如：《網路安全法》規定：採取監測、記錄網路運作狀態、網路安全事件的技術措施，並依照規定留存相關的網路日誌不少於六個月）。 ',
  privacy64: '出於財務、審計、爭議解決等目的需要合理延長期限的。 ',
  privacy65: '我們非常重視你個人資訊的安全。目前，我們基於適用的法律法規要求，建立了高標準的個人資訊保護管理體系，並實施了安全技術措施來確保個人資訊處理全生命週期中的安全性與合規性，充分保障用戶隱私。我們的網路服務採取了傳輸層安全協定等加密技術，確保你的資料在網路傳輸過程的安全。 ',
  privacy66: '我們採用嚴格的資料處理權限​​控制，避免資料被違規使用。我們採用打碼屏蔽等去識別化技術的多種資料脫敏方式增強個人資訊在使用上的安全性。同時，我們採用業界廣泛應用的加密技術對你的個人資訊進行加密保存，並透過資料隔離技術進行隔離，並可能不時加以修訂完善以提升系統的整體安全性。 ',
  privacy67: '儘管已經採取了上述合理有效措施，並已經遵守了相關法律規定要求的標準，但請你理解，由於技術的限制以及可能存在的各種惡意手段，在互聯網行業，即便竭盡所能加強安全措施，也不可能始終保證資訊百分之百的安全，我們將盡力確保你提供給我們的個人資訊的安全性。請你知悉並瞭解，你連接到我們的服務所使用的系統和通訊網絡，有可能因我們可控範圍外的因素而出現問題。因此，我們強烈建議你採取積極措施保護個人資訊的安全，包括但不限於使用複雜密碼、定期修改密碼、不將自己的帳號密碼等個人資訊透露給他人。 ',
  privacy68: '在我們獲悉發生了你的個人資訊不幸被洩露、非法提供或濫用的個人資訊安全事件後，我們將按照法律法規的要求及時向你告知：安全事件的基本情況和可能的影響、我們已採取或將要採取的處置措施、你可自主防範和降低風險的建議、對你的補救措施等。事件相關情況我們將以推播通知的方式告知你，難以逐一告知個人資訊主體時，我們會採取合理、有效的方式發佈公告。同時，我們也將依照監理機關要求，上報個人資訊安全事件的處置情形。 ',
  privacy69: '你一旦瀏覽或使用其他網站、服務及內容資源，我們將沒有能力和直接義務保護你在使用第三方產品過程中提交的任何個人信息，無論你登錄、瀏覽或使用上述軟體、網站是否基於本服務的連結或引導。 ',
  privacy70: '我們非常重視你對個人資訊的管理，並盡全力保護你對於你個人資訊的查閱、複製、更正、補充、刪除、撤回同意授權、投訴舉報以及設定隱私功能等權利，以使你有能力保障你的隱私和資訊安全。 ',
  privacy71: '但請你理解，特定的業務功能和服務將需要你的信息才能得以完成，當你撤回同意或授權後，我們無法繼續為你提供對應的功能和服務，也不再處理你相應的個人資訊。但你撤回同意或授權的決定，不會影響我們先前基於你的授權而進行的個人資訊處理。 ',
  privacy72: '我們在不同的版本或作業系統中提供的管理方式的路徑可能會有差異，請以實際為準。 ',
  privacy73: '你可以直接在設備作業系統中自主開啟或關閉相關係統權限，改變同意範圍或撤回你的授權。撤回授權後我們將不再收集與該權限相關資訊。本服務透過穿山甲（CSJ）廣告 SDK 提供個性化廣告推薦（個性化推送）功能，根據你的裝置資訊、廣告瀏覽和點擊等操作資訊分析你的偏好，向你展示可能感興趣的廣告。「個性化廣告」開關預設開啟，你可以隨時進入應用程式內「設定」頁面，關閉「個性化廣告」開關。關閉後，將停止向你提供個性化廣告推薦，但你仍可能看到非個性化廣告，且不影響你使用應用程式的其他功能。',
  privacy75: '如果你有任何意見或你認為你的個人資訊權利可能受到侵害，或者發現侵害個人資訊權利的線索，你可以透過本隱私權政策公佈的聯絡方式與我們聯絡。 ',
  privacy76: '你可以在啟動頁面或者設定頁面查看本隱私政策的全部內容。',
  privacy77: '請你了解，本隱私權政策中所述的本服務的相關功能可能會根據你所使用的設備型號、系統版本、軟體應用程式版本等因素而有所不同。最終的產品和服務以你所使用的軟體及相關服務為準。 ',
  privacy78: '如我們停止運營，我們將及時停止收集你個人信息的活動，將停止運營的通知以逐一送達或公告的形式通知你，並對所持有的你的個人信息進行刪除或匿名化處理。 ',
  privacy79: '若你是未滿18歲的未成年人，在使用本服務前，應在你的父母或其他監護人監護、指導下共同閱讀並同意本隱私權政策。 ',
  privacy80: '若你是未成年人的監護人，當你對你所監護的未成年人的個人資訊有相關疑問時，請透過本隱私權政策公示的聯絡方式與我們聯絡。 ',
  privacy81: '為了提供你更好的服務，本服務將不時更新與變化，我們會適時對本隱私權政策進行修訂，這些修訂構成本隱私權政策的一部分並具有等同於本隱私權政策的效力，未經你明確同意，我們不會削減你依據目前生效的本隱私權政策所應享有的權利。 ',
  privacy82: '本隱私權政策更新後，我們會發出更新版本，並在更新後的條款生效前透過適當的方式提醒你更新的內容，以便你及時了解本隱私權政策的最新版本。如果你在本隱私權政策更新之後繼續使用本服務，也就是視為你接受更新後的隱私權政策。 ',
  privacy83: '與本隱私權政策相關的任何疑問、意見或請求，你可以將相關問題發送至',
  privacy84: '。一般情況下，我們會在收到你相關聯絡資訊並核實你身分後的十五個工作天內回覆。 ',
  privacy85: '對於與你的身份不直接關聯的信息、無效重複信息，或者需要過多技術手段、給他人合法權益帶來風險或者不切實際的請求，我們可能會予以拒絕。 ',
  privacy86: '本隱私權政策可能存在多種語言版本，如各語言版本條款出現不一致或衝突，以本隱私權政策中文簡體版本為準。 ',
  privacy87: '本隱私權政策中的標題僅為方便及閱讀而設，並不影響本隱私權政策中任何規定的含義或解釋。 ',
}
